<script>
import GoogleMaps from "@/components/_Shared/GoogleMaps";
import FloatingWarning from "@/components/_Shared/FloatingWarning";
import HolidayWarning from "@/components/_Shared/Warnings/Holiday";

import dateMixin from "@/mixins/dateMixin";
import timeMixin from "@/mixins/timeMixin";
import numberMixin from "@/mixins/numberMixin";
import orderMixin from "@/mixins/orderMixin";

export default {
  mixins: [dateMixin, timeMixin, numberMixin, orderMixin],

  components: {
    GoogleMaps,
    FloatingWarning,
    HolidayWarning
  },

  props: {
    order: {
      type: Object,
      required: true
    }
  },
  computed: {
    showRescheduleButton() {
      return this.canReschedule(this.order.status);
    }
  },
  data() {
    return {
      lat: null,
      lng: null
    };
  },

  methods: {
    getLatLng() {
      let arr = this.order.address.lonlat.split(" ");
      this.lng = parseFloat(arr[1].substr(1));
      this.lat = parseFloat(arr[2].substr(0, arr[2].length - 1));
    }
  },

  mounted() {
    this.getLatLng();
  }
};
</script>

<template>
  <div>
    <div class="pointer" @click="$router.push({name: 'checkout', params: {order_id: order.id}})">
      <floating-warning
        title="Você ainda não efetuou o pagamento deste pedido!"
        message="Clique aqui para efetuar o pagamento do pedido."
        positionY="bottom"
        positionX="center"
        :visible="canGoToCheckout(order)"
      />
    </div>

    <div class="title">
      pedido
      <div class="btn bg-purple"
        v-if="order.cycle_id">
        <router-link 
          :to="{name: 'cycle', params: {id: order.cycle_id}}">
          ir para a assinatura
        </router-link>
      </div>
      <div class="btn bg-purple"
        v-if="canGoToCheckout(order)">
        <router-link 
          :to="{name: 'checkout', params: {order_id: order.id}}">
          efetuar pagamento
        </router-link>
      </div>
    </div>
    <div class="minor-title">local</div>

    <div class="row">
      <p>
        <b>Rua:</b>
        {{order.address.street}}
      </p>

      <p>
        <b>CEP:</b>
        {{order.address.zip_code}}
      </p>

      <p>
        <b>Nº:</b>
        {{order.address.street_number}}
      </p>

      <p>
        <b>Complemento:</b>
        <span v-if="order.address.complement === ''">sem complemento</span>
        <span v-else>{{order.address.complement}}</span>
      </p>
    </div>

    <div class="row">
      <p>
        <b>Bairro:</b>
        {{order.address.district.display_name}}
      </p>

      <p>
        <b>Cidade:</b>
        {{order.address.district.city.display_name}}
      </p>

      <p>
        <b>Estado:</b>
        {{order.address.district.city.state.code}}
      </p>

      <p>
        <b>País:</b>
        {{order.address.district.city.state.country.display_name}}
      </p>
    </div>

    <div class="row">
      <p>
        <b>Referência de localização:</b>
        <span v-if="order.address.reference === ''">sem referência</span>
        <span v-else>{{order.address.reference}}</span>
      </p>
    </div>

    <div class="row">
      <p>
        <b>Geolocalização:</b>
        <google-maps
          v-if="lat && lng"
          name="geolocation"
          :lat="lat"
          :lng="lng"
          :withAutocomplete="false"
        />
      </p>
    </div>

    <div class="row">
      <p>
        <b>Informações sobre a limpeza:</b>
        {{order.description}}
      </p>
    </div>

    <div class="row mt-30">
      <div>
        <div class="minor-title">dia</div>
        <p class="mt-0 mb-20">{{order.schedule_event.starts_at | formatDate("dddd[, ]DD/MM/YYYY")}}</p>
      </div>

      <div>
        <div class="minor-title">duração</div>
        <p class="mt-0 mb-20">{{order.schedule_event.duration | secToHours(true)}}</p>
      </div>

      <div>
        <div class="minor-title">início</div>
        <p class="mt-0 mb-20">{{order.schedule_event.starts_at | formatDate("H[h]")}}</p>
      </div>

      <div>
        <div class="minor-title">profissional</div>
        <p
          class="mt-0 mb-20"
        >{{order.professional.account.first_name}} {{order.professional.account.last_name}}</p>
      </div>
    </div>

    <div class="row">
      <div>
        <div class="minor-title">status do pedido</div>
        <p class="mt-0 mb-20">{{order.status | getTranslatedName}}</p>
      </div>

      <div>
        <div class="minor-title">valor do pedido</div>
        <p class="mt-0 mb-20">{{order.total | intToCurrency}}</p>
      </div>

      <div>
        <div class="minor-title">total de desconto</div>
        <p class="mt-0 mb-20">
          {{order.amount.subtotal.discount | intToCurrency}}
          <span
            v-if="order.coupon"
            class="text-purple"
          >
            (cupom
            <b>{{order.coupon.name}}</b>)
          </span>
        </p>
      </div>

      <div>
        <div class="minor-title">Total do pedido</div>
        <p class="mt-0 mb-20">{{order.amount.total | intToCurrency}}</p>
      </div>
    </div>

    <holiday-warning :day="order.schedule_event.starts_at" />
  </div>
</template>

<style scoped>
.bg-purple a {
  color: #ffffff;
}

.row p,
.row div {
  flex: 1;
  margin-bottom: 0;
}

.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.minor-title {
  text-transform: uppercase;
  color: var(--purple);
  font-weight: bold;
  font-size: 14px;
}

@media (max-width: 768px) {
  .row,
  .row p {
    display: flex;
    flex-direction: column !important;
  }
}

@media (max-width: 450px) {
  .title .btn {
    padding: 5px 10px;
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Order/Data.vue